export default __webpack_public_path__ + "static/media/ictHealth2.de7518bd.jfif";